import { dateFnsLocales } from 'i18n/date-fns';
import { isAppLanguage } from 'i18n/is-app-language';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const FALLBACK_MONDAY_WEEK_START_ON = 1;

export const useGetWeekStartsOn = () => {
  const {
    i18n: { language },
  } = useTranslation();

  return useMemo(
    () =>
      isAppLanguage(language) ? dateFnsLocales[language].locale.options?.weekStartsOn : FALLBACK_MONDAY_WEEK_START_ON,
    [language],
  );
};
